import axios from 'axios'

export const getDomain = ()=>{
    let domain = document.domain;
    if (domain === 'localhost') {
        domain = 'https://sandconsole.hubblerapp.com'
    }
    else if (domain === 'website.eiris.in' || domain === 'www.hubblerapp.com') {
        domain = 'https://sandconsole.hubblerapp.com'
    } else{
        domain = 'https://hubbler.in'
    }
    return domain
};

const config = {
    headers: { 'content-type': 'application/json' ,'XMLHttpRequest': 'X-Requested-With'},
};


export const postCall = (url,data)=>{
    return axios.post(`${getDomain()}${url}`, data)
}

export const getCall = (url)=>{
    return axios.get(`${getDomain()}${url}`)
}


// WEBPACK FOOTER //
// ./src/components/common/domain.js